const translations = {
    pt: {
        preview: 'Preview',
        page: 'Página',
        of: 'de',
        typeHere: 'Digite seu texto aqui...',
        save: 'Salvar',
        task: 'Tarefa',
        chapter: 'Capítulo',
        back: 'Voltar',
        showPreview: 'Mostrar Preview',
        pagePreview: 'Pré-visualização da Página',
        contentUpdated: 'Conteúdo atualizado com sucesso',
        updateFailed: 'Falha ao atualizar conteúdo',
        tagPlaceholder: 'Digite uma tag...',
        addTag: 'Adicionar Tag',
        loadingData: 'Carregando dados...',
         textComparison: 'Comparação de Texto',
        originalVersion: 'Versão Original',
        currentVersion: 'Versão Atual',
        showDiff: 'Mostrar Diferenças',
        hideDiff: 'Ocultar Diferenças',
        resetComparison: 'Resetar Comparação',
        scrollView: 'Visualização em Scroll',
        paginatedView: 'Visualização Paginada',
    },
    en: {
        preview: 'Preview',
        page: 'Page',
        of: 'of',
        typeHere: 'Type your text here...',
        save: 'Save',
        task: 'Task',
        chapter: 'Chapter',
        back: 'Back',
        showPreview: 'Show Preview',
        pagePreview: 'Page Preview',
        contentUpdated: 'Content updated successfully',
        updateFailed: 'Failed to update content',
        tagPlaceholder: 'Type a tag...',
        addTag: 'Add Tag',
        loadingData: 'Loading data...',
        textComparison: 'Text Comparison',
        originalVersion: 'Original Version',
        currentVersion: 'Current Version',
        showDiff: 'Show Differences',
        hideDiff: 'Hide Differences',
        resetComparison: 'Reset Comparison',
        scrollView: 'Scroll View',
        paginatedView: 'Paginated View',
    },
};


export default translations;